import { configureStore } from "@reduxjs/toolkit";
import textsSlice from "./slices/textsSlice"

export default configureStore({
    reducer: {
        texts: textsSlice
    }
})